module.exports = __webpack_public_path__ + "static/media/biocertica-default.43c3e625.svg";